import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://segmed.developermonkeys.com/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : undefined;
};

export const patientApi = {
  getPatients: () => axios.get(`${API_BASE_URL}/patients`, { headers: getAuthHeaders() }),
  createPatient: (payload) => axios.post(`${API_BASE_URL}/patients`, payload, { headers: getAuthHeaders() }),
  getPatientById: (id) => axios.get(`${API_BASE_URL}/patients/${id}`, { headers: getAuthHeaders() }),
  updatePatient: (id, payload) => axios.put(`${API_BASE_URL}/patients/${id}`, payload, { headers: getAuthHeaders() }),
  getPatientIcuEntries: (id) => axios.get(`${API_BASE_URL}/icu/patient/${id}`, { headers: getAuthHeaders() }),
  enterPatientIcu: (id, body) => axios.post(`${API_BASE_URL}/icu/${id}/enter`, body, { headers: getAuthHeaders() }),
  leavePatientIcu: (entryId) => axios.put(`${API_BASE_URL}/icu/leave/${entryId}`, {}, { headers: getAuthHeaders() }),
  getPatientEvents: (id) => axios.get(`${API_BASE_URL}/events/patient/${id}`, { headers: getAuthHeaders() }),
  createPatientEvent: (payload) => axios.post(`${API_BASE_URL}/events`, payload, { headers: getAuthHeaders() }),
  deleteIcuEntry: (entryId) => axios.delete(`${API_BASE_URL}/icu/${entryId}`, { headers: getAuthHeaders() }),
  deletePatientEvent: (eventId) => axios.delete(`${API_BASE_URL}/events/${eventId}`, { headers: getAuthHeaders() }),
  deletePatient: (id) => axios.delete(`${API_BASE_URL}/patients/${id}`, { headers: getAuthHeaders() }),
};
